import React from 'react';

import { Form } from 'antd';
import Cache from '../../frame/Cache';
import { Input, InputGroup, Icon } from 'rsuite';

import Config from '../../config/Config'
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetModal from '../../widget/WidgetModal';
import WidgetTable from '../../widget/WidgetTable';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetComponent from '../../widget/WidgetComponent';
import WidgetSelect from '../../widget/WidgetSelect';
import WidgetDrawer from "../../widget/WidgetDrawer"
import WidgetTreePicker from '../../widget/WidgetTreePicker';

import 'antd/dist/antd.css';
import './css/system.css';

let arr = [
    {
    id: "1",
    name: "前端测试",
    serial: 1,
    realm_id: "1"
    },
    {
        id: "2",
        name: "前端测试2",
        serial: 2,
        realm_id: "2"
    },
]

class Role extends WidgetComponent
{
    constructor( props )
    {
        super(props);

        let path = Config.getBasePath();
        let group;

        if( path.endsWith('/')===false )
        {
            path = path + '/';
        }
        if( this.props.location!==undefined && this.props.location.state!==undefined )
        {
            group = this.props.location.state.group;
        }

        let userInfo = sessionStorage.getItem("_user_info_");

        if( userInfo!==undefined && userInfo!==null )
        {
            userInfo = JSON.parse(userInfo);
        }

        
        this.state = {
            userInfo,userInfo,
            path : path,
            keyWord : undefined,
            data : undefined,
            total : undefined,
            options : {
                records : 10
            },
            columns:[
                { name: 'id', title: '用户组id', type: 'string', description: '用户组id', properties: { hidden: true }},
                { name: 'name', title: '角色名称', type: 'string', description: '用户组名称', properties: { hidden: false , click:"clickUserName" }},
                { name: 'realmName', title: '用户领域', type: 'string', description: '用户领域名称', properties: { hidden: false, transform: "transformRole"}},
                { name: 'remark', title: '备注', type: 'string', description: '备注', properties: { hidden: false }},
                { name: 'operation', title: '操作', type: 'string', description: '操作', 
                    properties: {hidden: false, 
                        operations: [
                            //   { name: '管理', click: "groupManage" },
                          { name: '配额管理', click: 'quotaManage'},
                          { name: '权限配置', type:"icon", click: "groupPrivilege",},
                          { name: '编辑', type:"icon", click: "groupEdit",},
                          { name: '删除', type:"icon", click: "groupRemove",}
                        ],
                        transform: "transformOperations"
                    }
                },
              
            ],
            departmentTreeoptions : {
                title:"请选择用户领域",
                type : 'select'
            },
            editRroupModelOptions : {
                title : "新增用户",
                confirm : "确定",
            },
            Group : {},
            removeGroup : {

            },
            layout : {
                labelCol: { span: 6 },
                wrapperCol: { span: 16 },
            },
            messageOptions : {
                title : "信息",
            },
            quotaOptions:{
                title:'配额管理',
                confirm:'确定'
            },
            quotaData:[],
            selectoptions:{},
            groupData: [{
                id:0,
                value:0,
                label:'天',
                title:'天'
            },{
                id:1,
                value:1,
                label:'周',
                title:'周'
            },{
                id:2,
                value:2,
                label:'月',
                title:'月'
            },{
                id:3,
                value:3,
                label:'年',
                title:'年'
            }],
            tabelPageIndex:1,
            drawerOptions: {
                size: 'md',
                button: false,
            },
            clickUserData:{},
            tableData:{},
            group : group!==undefined ? group : {},
            filterBankData:undefined,
            flag:false
        };
        
        this.onEvent = this.onEvent.bind(this);
        
        this.pageTurning = this.pageTurning.bind(this);
        this.createRroup = this.createRroup.bind(this);
        this.groupSearch = this.groupSearch.bind(this);
        this.removeGroup = this.removeGroup.bind(this);
        this.submitGroup = this.submitGroup.bind(this);
        this.keyWordKeyUp = this.keyWordKeyUp.bind(this);
        this.inputOnchange = this.inputOnchange.bind(this);
        this.removeConfirm = this.removeConfirm.bind(this);
        this.keyWordOnChange = this.keyWordOnChange.bind(this);
        this.onSubmitGroup = this.onSubmitGroup.bind(this);
        this.onRemoveGroup = this.onRemoveGroup.bind(this); 
        this.onGroupSearch = this.onGroupSearch.bind(this);
        this.onLoadQuota = this.onLoadQuota.bind(this);
        this.quotaManager = this.quotaManager.bind(this);
        this.onQuotaManager = this.onQuotaManager.bind(this);
        this.belongs = this.belongs.bind(this);
        this.onBelongs = this.onBelongs.bind(this);
        this.parentDepartmentOnSelect = this.parentDepartmentOnSelect.bind(this); 
        this.transformOperations = this.transformOperations.bind(this);

        // this.loadGroupPrivilege = this.loadGroupPrivilege.bind(this);
        // this.onLoadGroupPrivilege = this.onLoadGroupPrivilege.bind(this);  
        // this.buildGroupPrivilege = this.buildGroupPrivilege.bind(this);

        // this.loadUserDetail = this.loadUserDetail.bind(this);
        // this.onLoadUserDetail = this.onLoadUserDetail.bind(this);
    }


    
    componentDidMount()
    {
        this.groupSearch(1);
        this.belongs()
    }

    /**
     * 把子组件注入到父主键里
     * @param {*} ref 
     */
    editGroupModelRef = (ref) => {

        this.editGroupModelRef =  ref ;
    }

    messageRef = ( ref ) => {
        this.messageRef = ref;
    }


    /**
     * 部门信息input值变化触发函数
     * @param {*} value 
     * @param {*} type 
     */
    inputOnchange( value, type, item )
    {
        switch( type )
        {
            case "name":
            {
                this.state["GroupName"] = value;
                break;
            }
            case "remark":
            {
                this.state["GroupRemark"] = value;
                break;
            }
            case 'quota':
                item.AMOUNT = Number(value);
                this.setState({
                    ...this.state.quotaData,
                    ...item
                })
                break;
            default:
                break;
        }
    }


    paramsChange(value,item){
        item.PERIOD=value;
        this.setState({
            ...this.state.quotaData,
            ...item
        })
    }

    // 用户归属
    belongs()
    {
        const { path } = this.state;

        WidgetAjax.ajax({url:path + 'realm/search', params:{ page:1,records:9999}, callback:this.onBelongs});
    }

    onBelongs(result)
    {
        let {userInfo,departmentTreeoptions} = this.state;

        if( result.status===0 )
        {
            let filterBankData = [];

            for(let item of result.results)
            {
                item["value"] = item.id;
                item["label"] = item.name;

                filterBankData.push(item);
            }
            for(let item of filterBankData){
                if(item.value == userInfo.realmId){

                    departmentTreeoptions["title"] = item.label
                    this.setState({flag:true})
                }
            }

            this.setState({filterBankData:filterBankData});
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 父部门选择
     * @param {*} values 
     */
     parentDepartmentOnSelect( values )
     {
         let {userInfo} = this.state
         if( values!==undefined && values.length===1 )
         {
             this.state["roleDefaultValues"] = values[0];
         }
     }

    /**
     * 表格点击事件
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     */
    onEvent(type, data, value, event)
    {
        // if( data!==undefined )
        // {
        //     data = JSON.parse(data);
        // }

        switch( type )
        {
            case "transformOperations":
            {
                return this.transformOperations(data, value);
            }
            case "transformRole":
            {
                return this.transformRole(data, value);
            }
            case 'quotaManage':
            {
                data = JSON.parse(data);
                return this.quota(data);
                
            }
            case "groupEdit":
            {
                data = JSON.parse(data);
                return this.editGroup(data);
            }
            case "groupRemove":
            {
                data = JSON.parse(data);
                return this.removeGroup(data);
            }
            case "clickUserName":
            {
                data = JSON.parse(data);
                this.setState({
                    clickUserData:data
                })
            }
            case "groupManage":
            {
                data = JSON.parse(data);
                this.props.history.push({pathname:'/home/roleUser', state:{group:data}});
                break;
            }
            case "groupPrivilege":
            {
                data = JSON.parse(data);
                this.props.history.push({pathname:'/home/rolePrivilege', state:{group:data}});
                break;
            }
            
        }
    }

      /**
     * 操作格式化
     * @param {*} data 
     * @param {*} content 
     * @returns 
     */
       transformOperations(data, content) 
       {
           if (content.props !== undefined && content.props.children !== undefined) 
           {
               for (let i = 0; i < content.props.children.length; i++) 
               {
   
                   let child = content.props.children[i];
   
                   if (child.props.className === "marketingAddMonitor") 
                   {
                       if (data.MONITOR === true) {
                           content.props.children.splice(i, 1);
                           i--;
                       }
                   }
                   else if (child.props.className === "addCRM") 
                   {
                       if (data.CRM === true) 
                       {
                           content.props.children.splice(i, 1);
                           i--;
                       }
                   }
               }
           }
   
           return content;
       }

    transformRole=(data, value)=>{
        let date=''
        console.log(data.realm_id);
        switch(data.realm_id)
        {
            
            case '1':
            date='上海银行'
            break;
            case '2':
            date='兴业银行'
            break;
            case '3':
            date='紫金银行'
            break;
            case '4':
            date='民生银行'
            break;
            
        }
        return date ;
    }

    quota(data){
        this.quotaModelRef.open();
        let { path } = this.state;

        WidgetAjax.ajax({url: path + "role/limit", params: {id:data.id} , callback: this.onLoadQuota});
        this.state["resetpwd"]=data
    }
    onLoadQuota(result){
        this.setState({
            quotaData:[],
        })
        if( result.status===0 )
        {
            this.setState({
                quotaData:result.results,
            })
        }
        else if( result.status===10 ) 
        {
            Cache.logout(this.props);
        }
        else
        {
            this.setState({
                quotaData:[{TYPE:1},{TYPE:2},{TYPE:3}],
            })
        }
    }
    quotaManager(){
        let { path,quotaData,resetpwd } = this.state;
      
        WidgetAjax.ajax({url: path + "role/set_limit", params: {id:resetpwd.id,limits:quotaData} , callback: this.onQuotaManager});
    }
    onQuotaManager(result){
        let { messageOptions } = this.state;
        messageOptions["isMessage"] = true;

        if( result.status===0 )
        {
            messageOptions["message"] = '配额设置成功！' ;
        }
        else
        {
            messageOptions["message"] = "配额设置失败！" ;
        }
        this.state["messageOptions"] = messageOptions;
        this.messageRef.open();
    }
    quotaModelRef=(ref)=>
    {
      this.quotaModelRef=ref
    }


    /**
     * 创建角色
     */
    createRroup()
    {
        this.state["isCreate"] = true;
        
        let {editRroupModelOptions} = this.state
        editRroupModelOptions.title = "新增角色"
        this.setState({Group:{}, RroupId:undefined });

        this.editGroupModelRef.open();
    }

    /**
     * 编辑角色
     */
    editGroup( data )
    {
        let {editRroupModelOptions} = this.state

        this.state["isCreate"] = false;
    
        if( data!==undefined )
        {
            this.setState({Group:data, RroupId: data.id});
        }
        editRroupModelOptions.title = "编辑角色"

        this.editGroupModelRef.open();
    }

    /**
     * 创建角色，编辑部门确定函数
     */
    submitGroup()
    {
        const { RroupId, GroupName, GroupRemark, path, isCreate ,Group , messageOptions,roleDefaultValues,userInfo} = this.state;
        
        if(isCreate){
            if( GroupName === null || GroupName === "" || GroupName === undefined )
            {
                messageOptions["message"] = "角色名称不能为空！";

                messageOptions["isMessage"] = true;

                this.messageRef.open()
                return;
            }
        }

        let params = {
            name : GroupName,
        }

        if(GroupRemark === undefined && GroupRemark === null && GroupRemark === ""){
            params["remark"] = ""
        }
        else
        {
            params["remark"] = GroupRemark
        }

        if( roleDefaultValues!==undefined && roleDefaultValues!==null) 
        { 
            params['realm_id'] = roleDefaultValues;
        }
        else{
            params['realm_id'] = userInfo.realmId
        }

        if( RroupId!==undefined && RroupId!==null) 
        { 
            params["id"] = RroupId;
            // params["name"]=Group.name
        } 

        if( isCreate )
        {
            WidgetAjax.ajax({url:path + 'role/create', params:params, callback:this.onSubmitGroup});
        }
        else
        {
            WidgetAjax.ajax({url:path + 'role/update', params:params, callback:this.onSubmitGroup});
        }
    }

    /**
     * 角色添加/修改回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onSubmitGroup( result, params )
    {
        
        let { messageOptions, isCreate } = this.state;

        messageOptions["isMessage"] = true ;

        if( result.status===0 )
        {
            if( isCreate )
            {
                messageOptions["message"] = "角色 '" + params.name +"' 创建成功！" ;
            }
            else
            {
                messageOptions["message"] = "角色 '" + params.name +"' 修改成功！" ;
            }

            this.groupSearch(1);

            this.messageRef.open();
        }
        else if( result.status === -1 )
        {

            messageOptions["message"] = result.message;

            this.messageRef.open();
        }
    }

    /**
     * 删除角色
     * @param {*} data 
     */
    removeGroup( data )
    {

        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false ;
        messageOptions["message"] = `确定要删除角色 '` + data.name +`' 吗? 删除后，记录将不能恢复！` ;
        messageOptions["confirmFunction"] = this.removeConfirm;
        
        this.state["removeGroup"] = data;

        this.state["messageOptions"] = messageOptions;

        this.messageRef.open();
    }

    /**
     * 删除确认函数
     */
    removeConfirm()
    {
        const { path, removeGroup } = this.state;

        if( removeGroup!==undefined )
        {
            let params = {
                id : removeGroup.id,
                name:removeGroup.name
            }
    
            WidgetAjax.ajax({url:path + 'role/remove', params:params, callback:this.onRemoveGroup});
        }
    }

    /**
     * 角色删除回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onRemoveGroup( result, params )
    {
        let { messageOptions, tabelPageIndex } = this.state;

        messageOptions["title"] = "删除角色";
        messageOptions["isMessage"] = true;

        if( result.status === 0 )
        {
            messageOptions["message"] = "角色 '" + params.name +"' 删除成功！" ;

            this.state["messageOptions"] = messageOptions;

            this.messageRef.open();
        }
        else
        {
            messageOptions["message"] = "角色 '" + params.name +"'" + result.message +"" ;

            this.state["messageOptions"] = messageOptions;

            this.messageRef.open();
        }

        this.groupSearch(tabelPageIndex);
    }

    /**
     * 角色管理
     * @param {*} data 
     */
    groupManage( data )
    {

    }

    /**
     * 搜索关键字变化回调函数 
     * @param {*} value 
     * @param {*} event 
     */
    keyWordOnChange(value, event)
    {
        this.setState({keyWord:value});
    }

    /**
     * 键盘事件捕获
     * @param {*} e 
     */
    keyWordKeyUp( e )
    {
        /** 判断是否是回车事件 */
        if( e.keyCode===13 )
        {
            this.groupSearch();
        }
    }

    /**
     * 角色搜索函数
     */
    groupSearch( page )
    {
        const { path, keyWord, options,userInfo } = this.state;
        if( page===undefined )
        {
            page = 1;
        }

        let params = {
            page : page,
            records : options.records
        };

        if(userInfo.realmId !== undefined && userInfo.realmId !== null && userInfo.realmId !== "")
        {
            params["realm_id"] = userInfo.realmId;
        }
        

        if( keyWord!==undefined && keyWord!==null && keyWord!=="" )
        {
            params["name"] = keyWord;
        }

        WidgetAjax.ajax({url:path + 'role/search', params:params, callback:this.onGroupSearch});
    }

    /**
     * 角色搜索回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onGroupSearch( result, params )
    {
        if( result.status===0 )
        {
            let { options } = this.state;

            options["page"] = params.page;

            this.setState({data:result.results, total:result.total, options:options});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 表格翻页
     * @param {*} page 
     */
    pageTurning( page )
    {
        this.groupSearch(page);
        this.setState({
            tabelPageIndex:page
        })
    }

    /**
     * 上级部门Id选择
     * @param {*} value 
     * @param {*} item 
     * @param {*} event 
     */
    onDepartmentSelect(value, item, event)
    {

    }

    // loadGroupPrivilege()
    // {
    //     const { clickUserData, path } = this.state;

    //     let params = {
    //         id : clickUserData.id
    //     }

    //     WidgetAjax.ajax({url:path + 'role/privilege', params:params, callback:this.onLoadGroupPrivilege});
    // }

    // onLoadGroupPrivilege( result, params )
    // {
    //     console.log(result)
    //     if( result.status===0 )
    //     {
    //         this.buildGroupPrivilege(result.result);
    //     }
        // else if (result.status === 10) 
        // {
        //     Cache.logout(this.props);
        // }
    // }

    // buildGroupPrivilege( data )
    // {
       

    // }


    /** 用户详情信息抽屉句柄 */
    drawerRef = (ref) => {
        this.drawerRef = ref;
    }
    render()
    {
        const { columns, data, total, keyWord, options, editRroupModelOptions, 
                Group, layout, messageOptions, quotaOptions, quotaData, selectoptions, 
                groupData, drawerOptions, clickUserData, departmentTreeoptions, filterBankData, flag,roleDefaultValues} = this.state;
        editRroupModelOptions["confirmFunction"] = this.submitGroup;
        quotaOptions['confirmFunction']=this.quotaManager;

        return (
            <div className="page role-page page-overflow">
                <div className="page-content" style={{height:"100%",width:"100%",borderRadius:"0",boxShadow:"none"}}>
                    <div className="content-canvas content-top-frame-height height-100" style={{borderRadius:"0",boxShadow:"none"}}>
                        <div className="content-title Addroles content-title-addroles" style={{borderRadius:"0",boxShadow:"none"}}>
                            <div className="button" onClick={this.createRroup}>
                                <span className="addUser click">新增角色</span>
                            </div>
                            <div className="search">
                                <InputGroup className="InputGroup"  >
                                    <Input name="Serchkey" defaultValue={keyWord} placeholder="请输入关键词进行搜索" onChange={this.keyWordOnChange } onKeyUp={this.keyWordKeyUp} />
                                    <InputGroup.Addon><Icon icon="search" onClick={this.groupSearch} /></InputGroup.Addon>
                                </InputGroup>
                            </div>
                        </div>

                        <div className="content-chart-height content-table">
                            <WidgetTable tableRowHight={55} options={options} columns={columns} data={data} total={total} 
                                         notify={this.onEvent} pageTurning={this.pageTurning} source="./img/icon/" ></WidgetTable>
                        </div>
                    </div>
                </div>

                <WidgetModal options={editRroupModelOptions} onRef={this.editGroupModelRef} >
                    <Form  {...layout} name="basic">
                        <Form.Item label="用户领域" className="first-label" name="parentId">
                            <WidgetTreePicker options={departmentTreeoptions} flag={flag} basic={true}  data={filterBankData} defaultValues={roleDefaultValues} onSelect={this.parentDepartmentOnSelect}></WidgetTreePicker>
                        </Form.Item>
                        <Form.Item label="角色名称" name="GoupName">
                            <Input defaultValue={Group.name} onChange={(value) => {this.inputOnchange(value, "name")}}></Input>
                        </Form.Item>
                        <Form.Item label="备注" name="remark">
                            <Input componentClass="textarea" defaultValue={Group.remark} onChange={(value) => {this.inputOnchange(value, "remark")}}></Input>
                        </Form.Item>
                    </Form>
                </WidgetModal>

                <WidgetModal options={quotaOptions} onRef={this.quotaModelRef}>
                    {
                        quotaData.map((item,key)=>{
                            return <div key={key} className='quota_item'>
                                <span className='quota_tit'>{item.TYPE===1?'外呼量':item.TYPE===2?'浏览记录':'下载记录'} : </span>
                                <div className='quota_item_position'>
                                    <Input defaultValue={item.AMOUNT} onChange={(value) => {this.inputOnchange(value, "quota",item)}}></Input>
                                </div>
                                <WidgetSelect options={selectoptions} data={groupData} onSelect={(value)=>this.paramsChange(value,item)} defaultValue={item.PERIOD} ></WidgetSelect>
                            </div>
                        })
                    }
                </WidgetModal>

                <WidgetDrawer options={drawerOptions} onRef={this.drawerRef} >
                    <div style={{padding:"16px 24px"}}>
                        <h4>
                            用户详情页
                        </h4>
                        <table>
                            <tbody>
                                <tr>
                                    <td >用户名称</td>
                                    <td style={{paddingLeft:"5px"}}>{clickUserData.name}</td>
                                    {/* <td >曾用名</td>
                                    <td>{baseInfo.HISENTNAME}</td> */}
                                </tr>
                                <tr>
                                    <td >用户备注</td>
                                    <td style={{paddingLeft:"5px"}}>{clickUserData.remark}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </WidgetDrawer>

                <WidgetMessage options={messageOptions} onRef={this.messageRef} />
          </div>
        );
    }
}

export default Role


